import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end my-4" }
const _hoisted_2 = { class: "h-full overflow-y-auto" }
const _hoisted_3 = { class: "w-full text-sm text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" }, "Extra"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" }, "Twitter Format"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" }, "Options"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" })
  ])
], -1)
const _hoisted_5 = { class: "px-2 py-3" }
const _hoisted_6 = { class: "px-2 py-3" }
const _hoisted_7 = { class: "px-2 py-3" }
const _hoisted_8 = { class: "px-2 py-3" }
const _hoisted_9 = { class: "flex items-center px-2 py-3 gap-x-2" }
const _hoisted_10 = { class: "flex gap-x-2" }
const _hoisted_11 = { class: "flex flex-col w-96 gap-y-2" }
const _hoisted_12 = { class: "flex gap-x-10" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Dropdown Options", -1)
const _hoisted_15 = { class: "overflow-y-auto max-h-40" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "mt-2" }
const _hoisted_20 = { class: "flex items-center justify-between py-1" }
const _hoisted_21 = { class: "text-sm" }

import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { useTemplateStore } from '@/store/template';
import { cloneDeep } from 'lodash';
import Button from '@/components/UI/Button.vue';
import { Template, TemplateType } from '@/typings/template';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import { SearchItem } from '@/typings/dropdown';
import { PromptModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const promptModal = inject('promptModal') as Ref<PromptModal>;

const creationModalVisible = ref(false);
const extraTemplate = ref();
const newOption = ref('');
const types = ref<SearchItem[]>([
  {
    value: TemplateType.FreeText,
    text: 'Free text',
  },
  {
    value: TemplateType.Participants,
    text: 'All participating wrestlers',
  },
  {
    value: TemplateType.Number,
    text: 'Number +/- 1',
  },
  {
    value: TemplateType.Falls,
    text: 'All falls',
  },
  {
    value: TemplateType.NoDQFalls,
    text: 'No DQ Falls - Pin or submission only',
  },
  {
    value: TemplateType.CageFalls,
    text: 'Cage Falls - Pin, submission or escape',
  },
  {
    value: TemplateType.YesNo,
    text: 'Yes/No',
  },
  {
    value: TemplateType.AnyWrestler,
    text: 'All available wrestlers or custom',
  },
  {
    value: TemplateType.MultipleChoice,
    text: 'Custom Dropdown',
  },
  {
    value: TemplateType.Match,
    text: 'Match Names',
  },
  {
    value: TemplateType.OverUnder,
    text: 'Over/Under',
  },
]);

const templateStore = useTemplateStore();

function openCreate() {
  extraTemplate.value = {
    Text: '',
    Type: TemplateType.MultipleChoice,
    SocialFormat: '',
    UserNotes: '',
    Options: [],
  };
  creationModalVisible.value = true;
}

function editTemplate(editingTemplate: Template) {
  extraTemplate.value = cloneDeep(editingTemplate);
  creationModalVisible.value = true;
}

async function deleteTemplate(deletingTemplate: Template) {
  const doDelete = await promptModal.value.show(
    'Remove Template',
    'You are about to remove a template. Are you sure?'
  );
  if (doDelete) {
    await templateStore.deleteTemplate(deletingTemplate);
  }
}

async function saveModal() {
  if (extraTemplate.value.TemplateId) {
    await templateStore.editTemplate(extraTemplate.value);
  } else {
    await templateStore.addTemplate(extraTemplate.value);
  }
  creationModalVisible.value = false;
}

const modalHeader = computed(() =>
  extraTemplate.value?.TemplateId ? 'Edit a template' : 'Set up a template'
);

function addOption() {
  if (
    newOption.value.trim().length === 0 ||
    extraTemplate.value.Options.includes(newOption.value)
  )
    return;
  extraTemplate.value.Options.push(newOption.value);
  newOption.value = '';
}

function removeOption(index: number) {
  extraTemplate.value.Options.splice(index, 1);
}

onMounted(() => {
  templateStore.getTemplates();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Button, {
        label: "Add Template",
        onClick: openCreate
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStore).templates, (template) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: template.TemplateId,
              class: _normalizeClass(['border-t'])
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(template.Text), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(template.Type), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(template.SocialFormat), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(template.Options.length === 0 ? '' : template.Options), 1),
              _createElementVNode("td", _hoisted_9, [
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (editTemplate(template))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "pencil-alt" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (deleteTemplate(template))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "trash" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (extraTemplate.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[6] || (_cache[6] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Save",
              onClick: saveModal
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(TextField, {
                    modelValue: extraTemplate.value.Text,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((extraTemplate.value.Text) = $event)),
                    title: "Extra",
                    "max-length": 36
                  }, null, 8, ["modelValue"]),
                  _createVNode(TextField, {
                    modelValue: extraTemplate.value.SocialFormat,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((extraTemplate.value.SocialFormat) = $event)),
                    title: "Twitter Template"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(SearchDropdown, {
                  title: "Type",
                  modelValue: extraTemplate.value.Type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((extraTemplate.value.Type) = $event)),
                  items: types.value
                }, null, 8, ["modelValue", "items"]),
                _createVNode(TextField, {
                  modelValue: extraTemplate.value.UserNotes,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((extraTemplate.value.UserNotes) = $event)),
                  title: "User Notes",
                  multiline: ""
                }, null, 8, ["modelValue"])
              ]),
              (extraTemplate.value.Type === 'Multi')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraTemplate.value.Options, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index + option,
                          class: _normalizeClass([
              'flex items-center justify-between py-1',
              {
                'border-b': index !== extraTemplate.value.Options.length - 1,
              },
            ])
                        }, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(option), 1),
                          _createElementVNode("div", {
                            class: "text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-red-500 hover:opacity-100",
                            onClick: ($event: any) => (removeOption(index))
                          }, [
                            _createVNode(_component_fa_icon, { icon: "minus" })
                          ], 8, _hoisted_17)
                        ], 2))
                      }), 128))
                    ]),
                    (extraTemplate.value.Options.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Empty"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(TextField, {
                            modelValue: newOption.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newOption).value = $event)),
                            title: "Custom Option",
                            onKeyup: _withKeys(addOption, ["enter"])
                          }, null, 8, ["modelValue", "onKeyup"])
                        ]),
                        _createElementVNode("div", {
                          class: "mt-4 text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-green-500 hover:opacity-100",
                          onClick: addOption
                        }, [
                          _createVNode(_component_fa_icon, { icon: "plus" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})